module.exports = __webpack_public_path__ + "static/media/statistics_bg.a6ab50ea.png";